import React from "react";

const InputSelect = ({ options, placeholder }) => {
  return (
    <select
      className="form-select block w-full text-black rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
      placeholder={placeholder}
    >
      { options && options.map((option, index) => (
          <option value="#" key={index}>{ option }</option>
      ))}
    </select>
  );
};

export default InputSelect;
